import React from 'react';
import Badge from '@mui/material/Badge';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useClient } from "../../context/ClientProvider";

 
const NotificationBell = ({ notificationCount }) => {
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();
  return (
    <Badge
      badgeContent={notificationCount}
      color="secondary.main"
      sx={{
        '& .MuiBadge-badge': {
          fontSize: '0.85rem',
          height: '20px',
          width: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: "#FFF",
          backgroundColor: clientConfig.layout.secondaryGenericBackgroundColour || 'secondary.main',
          transform: 'translate(25%, 100%)',
          borderRadius: "50%",
          border: "1px solid #fff"
        },
      }}        
    >
      <NotificationsNoneOutlinedIcon fontSize='large' sx={{ color: "black", mt:3 }}>
      </NotificationsNoneOutlinedIcon>
    </Badge>
  );
};
 
export default NotificationBell;